import styled from 'styled-components';

export const VaccinationSection = styled.section`
  background: #f5fffc;
  box-shadow: 0px 1px 4px #d3d3d3;
  padding: 46px 16px 12px;
  border-radius: 6px;
  margin: 90px 12px 12px;
  position: relative;
`;

export const VaccinationTitle = styled.h1`
  font-size: clamp(1.25em, 2vw, 1.5em);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  text-align: center;
  padding-bottom: 16px;
`;

export const VaccinationTrackerImg = styled.img`
  width: 67px;
  height: 54px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const SectionCircle = styled.div`
  position: absolute;
  top: -70px;
  background-color: #f5fffc;
  box-shadow: 0px -1px 2px 0px #9c9c9c3d;
  width: 114px;
  height: 114px;
  border-radius: 50%;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const AgeListContainer = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-items: center;
  gap: 20px;
  margin: 12px 0;
`;

export const AgeList = styled.li`
  background: ${(props) => (props.disableList ? '#f5fffc' : '#54dab5')};
  display: block;
  width: 100%;
  color: ${(props) => (props.disableList ? 'hsl(0deg,0%,0%,87%)' : '#fff')};
  padding: 11px 0;
  text-align: center;
  border-radius: 6px;
  font-size: 13px;
  font-weight: ${(props) => (props.disableList ? '600' : '500')};
  height: 38px;

  a {
    width: 100%;
    display: inline-block;
  }
`;
